import {
	get,
	post,
	put,
	deleteRequestV2,
} from '../../api/usersModule/httpClient';
import { useEffect, useState } from 'react';
import { CDBModal } from 'cdbreact';
import { ModalRoles } from '../../Components/Modals/ModalRoles';
import { LargeCard } from '../Cards/LargeCard';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import { useDebounce } from '../../hooks/useDebounce';
const headers = ['ID', 'Rol', 'Estado'];
const defaultFormData = {
	RoleID: '',
	RoleName: '',
	RoleStatus: '',
	RoleDesc: '',
	RoleModules: {},
};

export const CrudRoles = ({ permissions, project }) => {
	const [data, setData] = useState([]);
	const [totalItems, setTotalItems] = useState(0);
	const [state, setState] = useState({ modal1: false });
	const [page, setPage] = useState(1);
	const [pressedButton, setPressedButton] = useState('');
	const [action, setAction] = useState('');
	const [selectedModule, setSelectedModule] = useState('');
	const [checkedOperations, setCheckedOperations] = useState([]);
	const [formData, setFormData] = useState(defaultFormData);
	const [formModules, setFormModules] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState('');
	const [itemsPerPage, setItemsPerPage] = useState(5);
	const [initialRender, setInitialRender] = useState(true);
	const [changePage, setChangePage] = useState(false);
	const debouncedSearch = useDebounce(search, 500);

	const getData = async (search, statusPage) => {
		setLoading(true);
		const data = await get(
			`/roles?page=${statusPage}&search=${search}&rowsPerPage=${itemsPerPage}`
		);
		setData(data.items);
		setTotalItems(data.pagination.found);
		setLoading(false);
	};

	useEffect(() => {
		if (initialRender) {
			setInitialRender(false);
			return;
		}
		
		
		if (!changePage) {
			getData(debouncedSearch, page);
		}else {
			setChangePage(false)
		}
	}, [page]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [debouncedSearch]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [itemsPerPage]);

	const getRole = async (id) => {
		const data = await get(`/roles?roleID=${id}`);
		setFormData({
			RoleID: data.items[0].roleID,
			RoleName: data.items[0].nombreRole,
			RoleStatus: data.items[0].active,
			RoleDesc: data.items[0].description,
			RoleModules: data.items[0].modules,
		});

		setFormModules(data.items[0].modules);
	};

	const convertDataToArray = () => {
		try {
			return data.map((item) => [
				item.roleID,
				item.nombreRole.charAt(0).toUpperCase() + item.nombreRole.slice(1).toLowerCase(),
				item.active ? 'Activo' : 'Inactivo',
			]);
		} catch (error) {
			console.error(error);
			return [];
		}
	};

	const toggle = (nr) => () => {
		let modalNumber = 'modal' + nr;
		setFormModules([]);
		setCheckedOperations([]);
		setSelectedModule('');
		setState({
			...state,
			[modalNumber]: !state[modalNumber],
		});
	};

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.id]: e.target.value });
	};

	const handleStatusChange = (e) => {
		setFormData({ ...formData, [e.target.id]: !formData[e.target.id] });
	};

	const handleModuleChange = (e) => {
		setSelectedModule(e.value);
	};

	const handleOperationCheck = (checkedOperation) => {
		const moduleOperations = Object.keys(formModules[selectedModule] ?? {});
		let isChecked = false;
		try {
			isChecked = formModules[selectedModule][checkedOperation];
		} catch (error) {
			isChecked = false;
		}

		if (isChecked) {
			setCheckedOperations(
				checkedOperations.filter((item) => item !== checkedOperation)
			);
		} else {
			setCheckedOperations([...checkedOperations, checkedOperation]);
		}

		if (moduleOperations.includes(checkedOperation)) {
			setFormModules({
				...formModules,
				[selectedModule]: {
					...formModules[selectedModule],
					[checkedOperation]: !isChecked,
				},
			});
		} else {
			setFormModules({
				...formModules,
				[selectedModule]: {
					...formModules[selectedModule],
					[checkedOperation]: true,
				},
			});
		}
	};

	const handleSubmit = async () => {
		const info = {
			roleID: formData.RoleID,
			nombreRole: formData.RoleName.charAt(0).toUpperCase() + formData.RoleName.slice(1).toLowerCase(),
			active: formData.RoleStatus,
			description: formData.RoleDesc.charAt(0).toUpperCase() + formData.RoleDesc.slice(1).toLowerCase(),
			modules: formModules,
			projectID: "1",
		};

		Swal.fire({
			title: `${action === "create" ? 'Creando' : 'Actualizando'} Rol`,
			text: 'Por favor, espere...',
			icon: 'info',
			allowOutsideClick: false,
			showCancelButton: false,
			showConfirmButton: false,
			willOpen: () => {
			  Swal.showLoading();
			},
		  });

		if (action === 'create') {
			delete info.roleID;

			await post('/roles', info);

			Swal.close();

			getData('', 1);
		} else {
			Swal.close();
			put('/roles', info);
		}
	};

	const deleteUser = async () => {
		const body = {
			roleID: formData.RoleID,
			projectID: "1",
		};

		const confirmDelete = await Swal.fire({
			title: 'Confirmar Eliminación del Rol',
			text: 'Esta acción eliminará de manera permanente el Rol seleccionado, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#146284',
			cancelButtonColor: '#EF4444',
			confirmButtonText: 'Sí, eliminar',
			cancelButtonText: 'Cancelar',
		});

		if (confirmDelete.isConfirmed) {

			Swal.fire({
				title: 'Eliminando Rol',
				text: 'Por favor, espere...',
				icon: 'info',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
				willOpen: () => {
					Swal.showLoading();
				},
			});

			await deleteRequestV2('roles', body, true);

			Swal.close();
			
			toggle(6)();
			getData('', 1);
		}
	};

	useEffect(() => {
		getData('', 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const moduleOperations = Object.keys(
			formModules[selectedModule] ?? {}
		).filter((key) => formModules[selectedModule][key] === true);
		setCheckedOperations(moduleOperations);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedModule]);

	useEffect(() => {
		switch (pressedButton.split(',')[0]) {
			case 'create':
				if (permissions['Crear']) {
					setAction('create');
					setFormData(defaultFormData);
					toggle(6)();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para crear roles',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'edit':
				if (permissions['Editar']) {
					setAction('edit');
					getRole(pressedButton.split(',')[1]);
					toggle(6)();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para editar roles',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'delete':
				if (permissions['Eliminar']) {
					deleteUser();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para borrar roles',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'refresh':
				setData(['']);
				getData('', 1);
				break;
			case 'closeModal':
				toggle(6)();
				break;
			case 'submitModal':
				handleSubmit();
				toggle(6)();
				break;
			default:
				break;
		}
		setPressedButton('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pressedButton]);

	return (
		<>
			<LargeCard
				name='Roles'
				headers={headers}
				loading={loading}
				data={convertDataToArray()}
				totalItems={totalItems}
				setPage={setPage}
				page={page}
				setChangePage={setChangePage}
				setPressedButton={setPressedButton}
				setSearch={setSearch}
				cState={true}
				itemsPerPage={itemsPerPage}
        		setItemsPerPage={setItemsPerPage}
			/>

			<CDBModal isOpen={state.modal6} toggle={toggle(6)}>
				<ModalRoles
					action={action}
					setPressedButton={setPressedButton}
					formData={formData}
					handleChange={handleChange}
					handleStatusChange={handleStatusChange}
					handleModuleChange={handleModuleChange}
					handleOperationCheck={handleOperationCheck}
					checkedOperations={checkedOperations}
					selectedModule={selectedModule}
				/>
			</CDBModal>
		</>
	);
};
